import { Box, Container, Typography } from '@mui/material';
import photo from '../assets/HeadBack.webp';
import backgroundImage from '../assets/modal.webp';
import PageBanner from './SectionPageBanner';

export default function TermsAndConditions() {
  return (
    <>
       <PageBanner image={photo} title="Policies" />
      <Box
        sx={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          py: { xs: 6, md: 10 },
          px: 2,
          color: 'white',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="body1"
            sx={{
              fontFamily: 'Nunito',
              lineHeight: 1.8,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              p: 3,
              borderRadius: 2,
            }}
          >
            1. Privacy Policy

            We collect limited user data for communication and service improvement.

            Data is not shared with third parties without consent.

            Data may be retained for legal, accounting, or reporting purposes.
            <br></br>
            2. Refund Policy

            Refund requests must be made in writing within 7 days of delivery.

            Refunds are not applicable for time-bound deliverables or services already consumed.

            Product-specific refund rules are listed on respective product pages.
            <br></br>
            3. Cancellation Policy

            Service cancellations must be requested in writing with a 15-day notice.

            Charges may apply for work completed or in progress.
            <br></br>
            4. Code of Conduct

            Clients and employees must maintain professional communication.

            Harassment, abuse, or unethical requests will lead to immediate termination of services.
            <br></br>
            5. Data Security Policy

            All client data is stored securely.

            Regular backups and encryption practices are followed.

            Clients must also adhere to best practices for password and access management.
            <br></br>
            6. Employment Policy

            The Company follows fair hiring practices.

            All employees must adhere to NDA and company ethics guidelines.
             <br></br>
            By using our website, you acknowledge that you have read, understood, and agree to these terms and policies.
          </Typography>
        </Container>
      </Box>
    </>
  );
}
